import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthorizationService } from '../authorization/authorization.service';

@Component({
  selector: 'app-payment-pending',
  templateUrl: './payment-pending.component.html',
  styleUrls: ['./payment-pending.component.scss']
})
export class PaymentPendingComponent implements OnInit {

  isChecking = false;
  errorMessage = '';
  checkCount = 0;
  private readonly MAX_CHECKS = 8;

  constructor(
    private authService: AuthorizationService,
    public router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.authService.recoverAuthenticationData();
      setTimeout(() => this.checkPaymentStatus(), 3000);
  }

  checkPaymentStatus(): void {
  if (this.isChecking) return;

  this.isChecking = true;
  this.errorMessage = '';
  this.checkCount++;

  this.authService.verifyPaymentStatus().subscribe({
    next: (res) => {
      this.isChecking = false;

      if (res.success) {
        this.toastr.success('Payment confirmed!', 'Success');
        this.router.navigate(['/payment-success'], {
          state: {
            referenceID: res.referenceID,
            pin: res.pin,
            alreadyPaid: res.alreadyPaid
          }
        });
      } else {
        this.errorMessage = res.message;

        if (res.error === 'INVALID_TOKEN' || res.error === 'TOKEN_EXPIRED') {
          this.toastr.error('Session expired. Please log in again.', 'Session Error');
          setTimeout(() => this.router.navigate(['/login']), 2000);
        } else if (this.checkCount < this.MAX_CHECKS) {
          // Auto-retry every 4 seconds — no need for user to click
          setTimeout(() => this.checkPaymentStatus(), 4000);
        }
      }
    },
    error: (err) => {
      this.isChecking = false;
      if (err.status === 401) {
        this.toastr.error('Session expired. Please log in again.', 'Session Error');
        setTimeout(() => this.router.navigate(['/login']), 2000);
      } else {
        this.errorMessage = 'Could not verify payment. Please try again.';
        if (this.checkCount < this.MAX_CHECKS) {
          setTimeout(() => this.checkPaymentStatus(), 4000);
        }
      }
    }
  });
}

  goBack(): void {
    this.router.navigate(['/auth-payment']);
  }
}